/** Google Calendar adapter — STUB. Implements CalendarPort. */
export function createGoogleCalendar() {
  const err = () => { throw new Error("GOOGLE_CALENDAR_NOT_IMPLEMENTED"); };
  return {
    async status() { return { status: "not_connected", vendor: "google" }; },
    async findAvailableSlots() { err(); },
    async bookMeeting() { err(); },
    async cancelMeeting() { err(); },
    async listEvents() { err(); },
  };
}
